import { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
import { canAssumeIdentity } from '../permissions';
import api from '../api';

export default function Header() {
  const { user, logout, viewAs, setViewAs, clearViewAs } = useAuth();
  const [users, setUsers] = useState([]);
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('ledger-dark') === '1');

  useEffect(() => {
    if (canAssumeIdentity(user)) {
      api.getUsers().then(setUsers).catch(() => {});
    }
  }, [user]);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
    localStorage.setItem('ledger-dark', darkMode ? '1' : '0');
  }, [darkMode]);

  return (
    <header className="app-header">
      <div className="header-left">
        <img src="/logo.png" alt="CM Corp" className="header-logo" />
        <div className="header-brand">
          <span className="header-app-name">Ledger</span>
          <span className="header-tagline">Financial Reporting</span>
        </div>
      </div>

      <div className="header-right">
        {canAssumeIdentity(user) && !viewAs && (
          <select
            className="assume-select"
            value=""
            onChange={e => { if (e.target.value) setViewAs(e.target.value); }}
          >
            <option value="">View as...</option>
            {users
              .filter(u => u.UserId !== user.userId && u.IsActive)
              .map(u => (
                <option key={u.UserId} value={u.Username}>{u.DisplayName} ({u.Role})</option>
              ))
            }
          </select>
        )}

        {viewAs && (
          <div className="viewing-as-badge">
            Viewing as <strong>{viewAs}</strong>
            <button onClick={clearViewAs} className="viewing-as-clear">&times;</button>
          </div>
        )}

        <button
          className="theme-toggle"
          onClick={() => setDarkMode(!darkMode)}
          title={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {darkMode ? (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
            </svg>
          ) : (
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
            </svg>
          )}
        </button>

        <div className="header-user">
          <span className="header-user-name">{user?.displayName}</span>
          <span className="header-user-role">{user?.role}</span>
        </div>
        <button onClick={logout} className="header-logout">Sign Out</button>
      </div>
    </header>
  );
}
